import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { WorkAreaService } from './work-area/work-area.service';
import { CfLoaderComponent, CFLoaderSize, CFLoaderStyle } from '@ui/cf-loader/cf-loader.component';

@Component({
    selector: 'app-job-redirect',
    templateUrl: './job-redirect.component.html',
    imports: [CommonModule, RouterModule, CfLoaderComponent]
})
export class JobRedirectComponent implements OnInit {
    LoaderSize = CFLoaderSize;
    LoaderStyle = CFLoaderStyle;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private workAreaService: WorkAreaService,
        private location: Location
    ) { }

    async ngOnInit(): Promise<void> {
        const jobId = this.route.snapshot.paramMap.get('jobId');
        const startingWorkAreaId =
            this.route.snapshot.queryParamMap.get('startingWorkAreaId');
        if (jobId) {
            const jobDetails = await this.workAreaService.getJobDetails(+jobId);
            if (jobDetails) {
                const workAreaTypeId = jobDetails.workAreaTypeId;
                const jobUrl = this.getJobUrl(
                    workAreaTypeId,
                    +jobId,
                    startingWorkAreaId
                );
                this.location.replaceState(jobUrl); // Replace the current URL in the browser history
                this.router.navigateByUrl(jobUrl, { replaceUrl: true }); // Navigate without adding to history
            } else {
                console.error('No job details found for the given jobId');
            }
        }
    }

    private getJobUrl(
        workAreaTypeId: number,
        jobId: number,
        startingWorkAreaId: string | null
    ): string {
        const baseUrl = (() => {
            switch (workAreaTypeId) {
                case 1: // Reference Approval
                    return `job/${jobId}/reference/profile`;
                case 3: // Medical Issue Review
                case 8: // New Medical Issue Review
                    return `job/${jobId}/medical/profile`;
                case 4: // Criminal Issue Review
                case 9: // Police Check Review
                    return `job/${jobId}/criminal/profile`;
                case 7: // Post-Placement Chase Up
                    return `job/${jobId}/chase-up/`;
                case 10: // Post failed OCR check review
                    return `job/${jobId}/criminal/failed-ocr-review`;
                case 13: // Returner Review
                    return `job/${jobId}/review/profile`;
                default:
                    console.log(`Unknown work area type id: ${workAreaTypeId}`);
                    return `job/${jobId}/review/profile`;
            }
        })();

        return startingWorkAreaId
            ? `${baseUrl}?startingWorkAreaId=${startingWorkAreaId}`
            : baseUrl;
    }
}
